<app-customer-account-dialog> 
<div id="content">
<div class="overlay filterData filterDataControls">
  <div class="overlay-header">
    <h6>Filters</h6>
    <div class="close-btn">
      <button mat-icon-button mat-dialog-close (click)="closeInteractionFilter()">
        <f-icon [iconConfig]="iconConfig"></f-icon>
      </button>
    </div>
  </div>
  <div class="section-divider"></div>
  <form id="filterForm" class="form-scroll">
    <div class="overlay-body">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <section  *ngIf="validateDateRange()" class="error-wrapper">
              <f-alert variant="error">
                Date selected should be within {{rootScope?.interactionHistoryConfig?.MAX_DAYS_FOR_LEGACYDATA}} days.
              </f-alert>
            </section>
            <section  *ngIf="rootScope.activeCustTab?.interactionFilterFail" class="error-wrapper">
              <f-alert variant="error">
                <p>There was a problem loading the data. 
                  <a (click)="getIHDataForListViewForDateRange()">Try again </a></p> 
              </f-alert>
            </section>
            </div>
            </div>
            <div class="row">
              <div class="col-md-12 date-range" >
            <h6>Date Range</h6><p>(Max date range is {{rootScope?.interactionHistoryConfig?.MAX_DAYS_FOR_LEGACYDATA}} days)</p>
          </div>
        </div>
        <div class="row border-bottom" [formGroup]="range">
          <div class="col-md-6 flex">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Date From (MMM-DD-YYYY)</mat-label>
              <input matInput [matDatepicker]="picker1" [max]="maxDate" formControlName="start"
                (dateChange)="addEvent( $event)">
              <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Date To (MMM-DD-YYYY)</mat-label>
              <input matInput [matDatepicker]="picker2" [min]="minDate" [max]="maxDate" formControlName="end">
              <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
              <mat-datepicker #picker2></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <!-- Angular autocomplete Chips -->
            <h6>Agent <span> (Max. 3 agents per search)</span> </h6>
            <mat-form-field appearance="fill" class="component-box chips">
              <mat-label>Type agent's name here e.g., Michaelangelo A</mat-label>
              <mat-chip-list #chipList aria-label="Agent selection">
                <mat-chip *ngFor="let agent of selectedAgents" (removed)="remove(agent)">
                  {{agent}}
                  <button matChipRemove>
                    <f-icon [iconConfig]="iconConfig"></f-icon>
                  </button>
                </mat-chip>
                <input placeholder="" #AgentInput [formControl]="AgentValue" [matAutocomplete]="auto"
                  [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                  (matChipInputTokenEnd)="add($event)">
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                <mat-option *ngFor="let agent of filteredAgent | async" [value]="agent">
                  {{agent}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <p class="error" *ngIf="isMaxAgents">Only 3 agents can be selected.</p>
          </div>

        </div>
        <div class="row section-divider "></div>
        <div class="row">
          <div class="col-md-12">

            <h6>Topic <span> (Max. 3 topics per search)</span> </h6>
            <mat-form-field appearance="fill" class="component-box chips">
              <mat-label>Type topics here. e.g., Health related</mat-label>
              <mat-chip-list #chipList2 aria-label="Topic selection">
                <mat-chip *ngFor="let topic of selectedTopics" (removed)="removeTopic(topic)">
                  {{topic}}
                  <button matChipRemove>
                    <f-icon [iconConfig]="iconConfig"></f-icon>
                  </button>
                </mat-chip>

                <input placeholder="" #topicInput [formControl]="topicValue" [matAutocomplete]="auto2"
                  [matChipInputFor]="chipList2" (matChipInputTokenEnd)="addTopic($event)">
              </mat-chip-list>
              <mat-autocomplete #auto2="matAutocomplete" (optionSelected)="selectedTopic($event)">
                <mat-option *ngFor="let topic of filteredTopic | async" [value]="topic" class="truncate">
                  {{topic}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <p class="error" *ngIf="isMaxTopics">Only 3 topics can be selected.</p>
          </div>
        </div>
        <div class="section-divider"></div>
        <div class="row domain-checkboxes">
          <div class="col-md-12" >
            <h6>Domain</h6>
             <f-checkbox-group
                    checkbox-group-name="Domain"
                  [checkboxItems]="rootScope.ihDomainLists"
                    variant="horizontal"
                    allow-multiple
                    (checkboxChecked)="domainList($event)">
                </f-checkbox-group>

          </div>
        </div>
        <div class="row section-divider"></div>
        <div class="row channel-list">         
          <div class="col-md-12 channel-checkboxes" >  
                  <h6>Channel</h6>
                  <f-checkbox-group
                    checkbox-group-name="Channel"
                  [checkboxItems]="rootScope.awldsCustomerIHChannelLists"
                    variant="horizontal"
                    allow-multiple
                    (checkboxChecked)="channelList($event)">
                </f-checkbox-group>

              </div>
        </div>
        <div class="row section-divider"></div>
      </div>
    </div>
  </form>
  <div class="button-controls">

    <f-button text="Clear all" title="Clear all" type="button" variant="action" (click)="clearAll()"></f-button>
    <f-button text="Apply" title="Apply" type="button" variant="progressive"
      [disabled]="disableApplyButton()"
      [ngClass]="{disableBtn:disableApplyButton()}"
      (click)="apply()"></f-button>
  </div>

  <app-loader *ngIf="rootScope.custAccInteractionFilterLoaderVariables.loader" [loaderType]="loaderType"
  [loaderMsg]="rootScope.custAccInteractionFilterLoaderVariables.loaderMsg"></app-loader>

</div>
</div>
</app-customer-account-dialog>